import { render, staticRenderFns } from "./listaSala.vue?vue&type=template&id=485ca569&scoped=true&"
import script from "./listaSala.vue?vue&type=script&lang=js&"
export * from "./listaSala.vue?vue&type=script&lang=js&"
import style0 from "./listaSala.vue?vue&type=style&index=0&id=485ca569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ca569",
  null
  
)

export default component.exports